module.exports = __webpack_public_path__ + "img/a7cdf85a5de1cd74630e08fc3df015fa.png";